// extracted by mini-css-extract-plugin
module.exports = {"headerBackgroundImage":"header-image_headerBackgroundImage__VRe_l","contentWrapper":"header-image_contentWrapper__rSJYO"};